
export default class SaleProductData {
    constructor(productId,productName,delivWeight,data) {
        this.productId = productId
        this.productName = productName
        this.delivWeight = delivWeight
        this.productData = data
        this.productData.product_class_list1.sort((a,b)=>{
            if(Number(a.classcategory_id1) > Number(b.classcategory_id1)){
                return 1
            } else {
                return -1
            }
        })
    }
    getImagePath() {
        return require("@/assets/" + this.productId + ".jpg");
    }

}
export { SaleProductData}